<script>
import OSS from "ali-oss";
import qrcode from './QrcodeView'

export default {
  name: "SupplyView",
  components: {
    qrcode
  },
  data() {
    return {
      queryData: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      dataList: [],
      disabled: true,
      selectChange: [],
      selectChangeId: [],
      title: '',
      DialogVisible: false,
      DialogVisibles: false,
      formData: {
        id: '',
        image: '',
        title: '',
        link: '',
        sort: '',
        remarks: ''
      },
      formRules: {},
      loading: true,
      item: {},           // 用于存储选中的产品信息
      saveImage: '',      // 用于保存二维码图片数据
      loadings: false
    }
  },
  created() {
    this.list()
  },
  methods: {
    handleUpload(option) {
      console.log(option)
      const _this = this
      let file = option.file;
      // lrz(file, {quality: 1}).then((rst) => {
      let formData = new FormData();
      formData.append("file", file);
      this.$axios.post('supply/sts/token').then(function (res) {
        const client = new OSS({
          region: res.data.data.region,
          accessKeyId: res.data.data.accessKeyId,
          accessKeySecret: res.data.data.accessKeySecret,
          bucket: res.data.data.bucket
        })
        const domain = res.data.data.domain
        const fileName = res.data.data.fileName
        client.put(fileName, file).then(() => {
          _this.formData.image = domain + fileName
          _this.$forceUpdate()
        })
      }).catch(function (err) {
        _this.$message.error(err)
      })
      // })
    },
    handleUploadTestReport(option) {
      console.log(option)
      const _this = this
      let file = option.file;
      // lrz(file, {quality: 1}).then((rst) => {
      let formData = new FormData();
      formData.append("file", file);
      this.$axios.post('supply/sts/token').then(function (res) {
        const client = new OSS({
          region: res.data.data.region,
          accessKeyId: res.data.data.accessKeyId,
          accessKeySecret: res.data.data.accessKeySecret,
          bucket: res.data.data.bucket
        })
        const domain = res.data.data.domain
        const fileName = res.data.data.fileName
        client.put(fileName, file).then(() => {
          _this.formData.testReport = domain + fileName
          _this.$forceUpdate()
        })
      }).catch(function (err) {
        _this.$message.error(err)
      })
      // })
    },
    handleUploadTechnological(option) {
      console.log(option)
      const _this = this
      let file = option.file;
      let formData = new FormData();
      formData.append("file", file);
      this.$axios.post('supply/sts/token').then(function (res) {
        const client = new OSS({
          region: res.data.data.region,
          accessKeyId: res.data.data.accessKeyId,
          accessKeySecret: res.data.data.accessKeySecret,
          bucket: res.data.data.bucket
        })
        const domain = res.data.data.domain
        const fileName = res.data.data.fileName
        client.put(fileName, file).then(() => {
          _this.formData.technological = domain + fileName
          _this.$forceUpdate()
        })
      }).catch(function (err) {
        _this.$message.error(err)
      })
      // })
    },
    list() {
      const _this = this
      this.$axios.post('supply/list', this.queryData).then(function (res) {
        _this.dataList = res.data.data.records
        _this.total = res.data.data.total
        _this.loading = false;
      }).catch(function (err) {
        _this.$message.error(err)
        _this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryData.pageSize = pageSize
      this.list()
    },
    handleCurrentChange(pageNo) {
      this.queryData.pageNo = pageNo
      this.list()
    },
    handleSearch() {
      this.queryData.pageNo = 1
      this.queryData.pageSize = 10
      this.list()
    },
    clear() {
      this.list()
    },
    handleAdd: function () {
      this.title = '新增产品'
      this.DialogVisible = true
    },
    handleEdit(id) {
      this.title = '编辑产品'
      this.DialogVisible = true
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('supply/detail', data).then(function (res) {
        _this.formData = res.data.data
      }).catch(function (err) {
        _this.$message.error(err)
      })
    },
    handleDelete(id) {
      const _this = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.delete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delete(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('supply/delete', data).then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            type: 'success',
            message: res.data.msg
          })
          _this.list()
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$message.error(err)
      })
    },
    changeSelect(val) {
      this.selectChange = val
      this.lengths = this.selectChange.length
      this.disabled = this.lengths === 0
    },
    getIds() {
      for (let i = 0; i < this.selectChange.length; i++) {
        this.selectChangeId.push(this.selectChange[i].id)
      }
    },
    // 批量删除按钮
    handleDeletes() {
      const _this = this
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.deleteAll()
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
        _this.selectChangeId = []
      })
    },
    deleteAll() {
      this.getIds()
      const _this = this
      this.loading = true
      this.$axios.post('supply/deletes', this.selectChangeId).then(function (res) {
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.list()
      }).catch(function (err) {
        _this.$message.error(err)
      })
    },
    handleSave(formRef) {
      const _this = this
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.$axios.post('supply/save', this.formData).then(function (res) {
            _this.formData.id = ''
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            _this.DialogVisible = false
            _this.list()
          }).catch(function (err) {
            _this.$message.error(err)
          })
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
    closeDialog() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },

    handleCode(item) {
      if (!item || !item.id) {
        this.$message.error('产品信息不完整，无法生成监管码');
        return;
      }
      this.item = item;
      // 清空之前的图片数据
      this.saveImage = '';
      // 确保对话框显示后再执行二维码生成
      this.DialogVisibles = true;
      // 使用 setTimeout 确保对话框完全渲染后执行
      this.$nextTick(() => {
        if (this.$refs.child && typeof this.$refs.child.bindQRCode === 'function') {
          this.$refs.child.bindQRCode();
        } else {
          console.error('Qrcode component not ready');
        }
      });
    },
    saveFile() {
      if (!this.saveImage) {
        this.$message.warning('没有可下载的图片');
        return;
      }

      // 检查是否为 Data URL
      if (this.saveImage.startsWith('data:image')) {
        // 将 Data URL 转换为 Blob
        const arr = this.saveImage.split(',');
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/png';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        const blob = new Blob([u8arr], {type: mime});
        const url = URL.createObjectURL(blob);

        // 创建下载链接
        const a = document.createElement('a');
        a.href = url;
        a.download = '监管码.png';

        // 添加到文档，触发点击，然后移除
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放 URL 对象
        URL.revokeObjectURL(url);
      } else {
        // 如果不是 Data URL，使用原始方法
        const saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        saveLink.href = this.saveImage;
        saveLink.download = '监管码.png';

        const event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        saveLink.dispatchEvent(event);
      }
    },
  }
}
</script>

<template>
  <div>
    <!--    <el-row style="margin-top:20px ">-->
    <!--      <el-col :span="4">-->
    <!--        <el-input placeholder="输入描述信息" v-model="queryData.title" clearable @clear="clear" ></el-input>-->
    <!--      </el-col>-->
    <!--      <el-col :span="3" style="margin-left: 20px">-->
    <!--        <el-button type="primary" @click="handleSearch">搜索</el-button>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <el-row style="text-align: left;margin-top: 20px">
      <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleAdd">新增</el-button>
      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeletes" :disabled="disabled">删除
      </el-button>
    </el-row>
    <el-table :data="dataList" style="width: 100%;margin-top: 20px" border @selection-change="changeSelect"
              v-loading="loading">
      <el-table-column type="selection" width="50" align="center" fixed></el-table-column>
      <!--      <el-table-column label="图片" prop="image" width="80" align="center">-->
      <!--        <template v-slot="scope">-->
      <!--          <el-image :src="scope.row.image"></el-image>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="产品名称" prop="name" align="center"></el-table-column>
      <el-table-column label="数量" prop="amount" align="center"></el-table-column>
      <el-table-column label="品质" prop="level" align="center"></el-table-column>
      <el-table-column label="产地" prop="address" align="center"></el-table-column>
      <el-table-column label="进货时间" prop="buyDate" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" align="center" width="200"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button size="mini" type="text" @click="handleCode(scope.row)">监管码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 20px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="DialogVisible" width="50%" center @close='closeDialog'>
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="100px">
        <el-form-item label="图片" prop="image" id="image" name="image">
          <el-upload class="avatar-uploader" :show-file-list="false"
                     drag
                     action
                     accept="*/**"
                     :http-request="handleUpload">
            <img v-if="formData.image" :src="formData.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品名称" prop="name" name="name">
          <el-input v-model="formData.name" name="name"></el-input>
        </el-form-item>
        <el-form-item label="生产商名称" prop="shopName" name="shopName">
          <el-input v-model="formData.shopName" name="shopName"></el-input>
        </el-form-item>
        <el-form-item label="许可证编号" prop="licenceNo" name="licenceNo">
          <el-input v-model="formData.licenceNo" name="licenceNo"></el-input>
        </el-form-item>
        <el-form-item label="执行标准" prop="standard" name="standard">
          <el-input v-model="formData.standard" name="standard"></el-input>
        </el-form-item>
        <el-form-item label="配料表" prop="ingredients" name="ingredients">
          <el-input v-model="formData.ingredients" name="ingredients"></el-input>
        </el-form-item>
        <el-form-item label="净重" prop="weight" name="weight">
          <el-input v-model="formData.weight" name="weight"></el-input>
        </el-form-item>
        <el-form-item label="存储方法" prop="storage" name="storage">
          <el-input v-model="formData.storage" name="storage"></el-input>
        </el-form-item>
        <el-form-item label="保质期" prop="shelf" name="shelf">
          <el-input v-model="formData.shelf" name="shelf"></el-input>
        </el-form-item>
        <el-form-item label="质量投诉电话" prop="phone" name="phone">
          <el-input v-model="formData.phone" name="phone"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="testReport" id="testReport" name="testReport">
          <el-upload class="avatar-uploader" :show-file-list="false"
                     drag
                     action
                     accept="*/**"
                     :http-request="handleUploadTestReport">
            <img v-if="formData.testReport" :src="formData.testReport" class="avatar"
                 style="width: 400px;height: 200px">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="工艺流程" prop="technological" id="technological" name="technological">
          <el-upload class="avatar-uploader" :show-file-list="false"
                     drag
                     action
                     accept="*/**"
                     :http-request="handleUploadTechnological">
            <img v-if="formData.technological" :src="formData.technological" class="avatar"
                 style="width: 400px;height: 200px">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remarks" name="remarks">
          <el-input v-model="formData.remarks" name="remarks"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel('formRef')">取 消</el-button>
    <el-button type="primary" @click="handleSave('formRef')">确 定</el-button>
  </span>
    </el-dialog>


    <el-dialog title="监管码" :visible.sync="DialogVisibles" width="50%" center @close='closeDialog'>
      <div class="d-flex justify-content-center">
        <qrcode :item="item" ref="child" :saveImage.sync="saveImage"></qrcode>
      </div>
      <div class="d-flex justify-content-center">
        <div id="code" class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadings" @click="saveFile()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>

.d-flex {
  display: flex;
}

.justify-content-center {
  justify-content: center;
}




.avatar {
  max-width: 100%;
  max-height: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.avatar-uploader {
  /* 确保上传区域有合适的最小高度 */
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 178px;
  text-align: center;
}

</style>